export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
export const websiteRegex =
  /^(https?:\/\/)?([\w\d-]+\.)*[\w\d-]+\.\w{2,}(\/.*)?$/;

export const validateForm = (formData) => {
  let errors = {
    name: "",
    email: "",
    website: "",
  };

  if (formData.name.length < 2) {
    errors.name = "Name must be at least 2 characters long";
  }
  if (!emailRegex.test(formData.email)) {
    errors.email = "Invalid email format";
  }
  if (!websiteRegex.test(formData.website)) {
    errors.website = "Invalid URL format";
  }

  return errors;
};

export const validateEmail = (email) => {
  const emailRegexp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return emailRegexp.test(email);
};

export const websiteValidation = (website) => {
  const websiteRegexp = /^(https?:\/\/)/;
  return websiteRegexp.test(website);
};
